/* ==========================================================================
   PanelAccommodation > Client > Config
   ========================================================================== */

/* Import modules */

/* Config */
const config = {
    component: 'PanelAccommodation',
    init: true,
    start: true,
    css: {
        self: 'panel-accommodation',
        room: 'panel-accommodation__room',
        addBtn: 'panel-accommodation__add',
        error: 'has-error'
    },
    type: {
        room: 'panel-accommodation-room',
        addBtn: 'panel-accommodation-add'
    },
    hooks: {
        rooms: 'panel-accommodation-rooms',
        error: 'panel-accommodation-error'
    },
    hideLabel: true,
    hasAdd: false,
    maxRooms: false,
    maxPeople: false
};

module.exports = () => config;
